import { Box } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildMySurveysDataTableFilter,
  useMySurveysDataTable,
} from 'generated/resources/datatable.graphql'

import { AccessSelector } from 'modules/core/components/AccessSelector'
import useFilter from 'modules/core/components/Filter/base/useFilter'
import i18n from 'modules/core/lib/i18n'

export const participantFilter = (source: ReturnType<typeof useMySurveysDataTable>) => {
  return buildMySurveysDataTableFilter(source, {
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'fullName',
        component: () => <AccessFilterBody />,
      },
    ],
    identifier: 'accessIdFilter',
    path: 'targetId',
    title: i18n.t('trainings.my_surveys.datatable.filters.participant'),
    default: true,
  })
}

const AccessFilterBody = () => {
  const { value, onValueChange } =
    useFilter<{ id: string; firstName: string; lastName: string; fullName: string }[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <AccessSelector
        hideBorder
        alwaysOpen
        withAvatar
        width="s400"
        multiple
        value={value?.map((item) => ({ ...item, id: Number(item.id) }))}
        onSelect={(selected) => {
          onValueChange(
            selected.map((item) => ({
              ...item,
              id: item.id.toString(),
            }))
          )
        }}
        emptyLabel={i18n.t('trainings.my_surveys.datatable.filters.empty_results')}
      />
    </Box>
  )
}
